<p>
  admin-product works!
</p>
